import { UPDATE_COMPANY_DATA } from './mutation-types'

export function updateCompany ({ commit }, company) {
  commit(UPDATE_COMPANY_DATA, company)
}
